
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LeadSourceType } from "@/types/leadSource";
import { UseFormReturn } from "react-hook-form";
import { useEffect } from "react";

interface LeadSourceFieldProps {
  form: UseFormReturn<any>;
  leadSources: LeadSourceType[];
  onLeadSourceChange?: (value: LeadSourceType) => void;
  value?: LeadSourceType;
}

export const LeadSourceField = ({ form, leadSources, onLeadSourceChange, value }: LeadSourceFieldProps) => {
  // Ensure form has the right value when component mounts or value changes
  useEffect(() => {
    if (value) {
      console.log("LeadSourceField: Setting lead source to:", value);
      form.setValue("leadSource", value);
    }
  }, [value, form]);

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="leadSource"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Select Lead Source</FormLabel>
            <Select 
              onValueChange={(value) => {
                field.onChange(value);
                console.log("LeadSourceField: onChange triggered with value:", value);
                onLeadSourceChange?.(value as LeadSourceType);
              }} 
              value={field.value || value}
              defaultValue={value}
            >
              <FormControl>
                <SelectTrigger className="h-14">
                  <SelectValue placeholder="Select lead source" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {leadSources.map((source) => (
                  <SelectItem key={source} value={source}>
                    {source}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />
    </div>
  );
};
